import $ from "jquery";
export default function () {
    if ($('.input-receipt-wrap').length) {
        $('body').on('click', '.input-receipt-wrap label', function () {
            const $container = $(this).parent();
            if ($container.find('.is-invalid').length) {
                $container.find('.is-invalid').removeClass('is-invalid');
                $container.find('.invalid-feedback').remove();
            }
        });
    }

    if ($('#productsAccordion').length) {
        $('body').on('focus', '#productsAccordion input', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid');
                $(this).parent().find('.invalid-feedback').remove();
            }
        });
        $('body').on('change', '#productsAccordion select', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid');
                $(this).parent().find('.invalid-feedback').remove();
            }
        });
    }

    if ($('.category__input').length) {
        $('body').on('click', '.category__input', function () {
            const $categories = $(this).parents('.categories');
            if ($categories.find('.is-invalid').length) {
                $categories.find('.is-invalid').removeClass('is-invalid');
                $categories.find('.invalid-feedback').remove();
            }
        });
    }
}
